
export const socialMedia = {
    
    github: 'https://github.com/TiavinaRakotobe',
    linkedin: 'https://www.linkedin.com/in/mamihenintsoa-rakotobe-77a014199/',
    twitter: 'https://twitter.com/Tiavina78987904',
    instagram: 'https://www.instagram.com/tiavinamamihents/',
    gmail: 'mamihenintsoaRakotobe@gmail.com',
    facebook: 'https://www.facebook.com/lindow.mind.1',
    skype :'https://join.skype.com/invite/nHze9LISFA9A',
    telegram: 'https://t.me/TiavinaRak',
}

export default socialMedia;